import axios from "@/plugins/axios";

export default {
  listPhoneSenders(
    params = {
      active: true,
      limit: 9999,
    }
  ) {
    return axios.httpApi.get("/phone_senders", { params });
  },

  getHistory(whatsapp_phone_sender_id) {
    return axios.httpApi.get("/whatsapp_phone_senders_history", {
      params: { whatsapp_phone_sender_id },
    });
  },

  updateStatus(id, params) {
    return axios.httpApi.put(`/phone_senders/${id}`, params);
  }
};
